/* @flow */
import {isEqual, toInteger} from 'lodash';

import {trigger as triggerEdap} from '../utils/edapWrapper';
import type {Store} from '../reducers/index';

// We want to ignore some changes in our search query param compare.
const queryParamsMask = {
    neLat: 0,
    neLong: 0,
    swLat: 0,
    swLong: 0,
    zoom: 0,
    include: [],
    ssr: false
};

export const triggerSearchEdap = (store: Store) => {
    // Since the first query is executed server-side this is used to set the parameters that were used once the page gets to the browser.
    const prevSearchParams = {
        ...store.getState().searchParams.prevParams,
        ...queryParamsMask
    };

    const currentSearchParams = {
        ...store.getState().searchParams.params,
        ...queryParamsMask
    };

    const searchTerm = store.getState().typeaheadSuggestion.term || '';

    // Per TRAVBUGS-62 fire the EDAP search events anytime the query params change except map coordinate changes.
    if (isEqual(prevSearchParams, currentSearchParams)) {
        return;
    }

    const {
        arrival,
        departure,
        petIncluded,
        childrenCount,
        adultsCount
    } = currentSearchParams;

    function getNightsCount(checkIn, checkOut) {
        const checkInDate = new Date(checkIn).setHours(0, 0, 0, 0);
        const checkOutDate = new Date(checkOut).setHours(0, 0, 0, 0);
        return Math.round((checkOutDate - checkInDate) / (24 * 60 * 60 * 1000));
    }

    function getEventRefinements(isDatedSearch) {
        const sleepsCount = toInteger(adultsCount) + toInteger(childrenCount);

        const adultsRefinement = `adults_${adultsCount}`;
        const childrenRefinement = `children_${childrenCount}`;
        const sleepsRefinement = `sleeps_${sleepsCount}`;
        const petsRefinement = `pets_${String(petIncluded)}`;

        let eventRefinements = [
            adultsRefinement,
            childrenRefinement,
            sleepsRefinement,
            petsRefinement
        ];

        if (isDatedSearch) {
            const currentDate = new Date().toISOString().slice(0, 10);
            const windowCount = getNightsCount(currentDate, arrival);

            const nightsCount = getNightsCount(arrival, departure);

            const nightsRefinement = `nights_${nightsCount}`;
            const windowRefinement = `window_${windowCount}`;

            eventRefinements = [
                ...eventRefinements,
                nightsRefinement,
                windowRefinement
            ];
        }
        return eventRefinements.join(',');
    }

    if (arrival && departure) {
        const nightsCount = getNightsCount(arrival, departure);
        const eventRefinements = getEventRefinements(true);

        triggerEdap('dated.search.submit', {
            startdate: arrival,
            enddate: departure,
            searchterm: searchTerm,
            withpets: petIncluded,
            numchildren: childrenCount,
            numadults: adultsCount,
            lengthofstay: nightsCount,
            actionlocation: 'search_form',
            eventrefinement: eventRefinements
        });
    } else {
        const eventRefinements = getEventRefinements(false);
        triggerEdap('search.submit', {
            searchterm: searchTerm,
            withpets: petIncluded,
            numchildren: childrenCount,
            numadults: adultsCount,
            actionlocation: 'search_form',
            eventrefinement: eventRefinements
        });
    }
    triggerEdap('search_query.submitted', {
        action_location: 'search',
        startdate: arrival ? arrival : '',
        enddate: departure ? departure : '',
        searchterm: searchTerm
    });
};
